import React from 'react';

function PrivacyPolicy() {
  return (
    <div className="page-content">
      <h2>隱私條款</h2>
      <p>這裡是教會簡介的內容。</p>
    </div>
  );
}

export default PrivacyPolicy;
